import * as React from 'react';
import cn from 'classnames';

import { useTheme } from '../../../../theme';
import { checkIconBig } from '../../Icons';
import { useTranslation } from 'react-i18next';

export interface ListItem {
	id: number;
	title: string;
}

interface Props {
	categories: ListItem[];
	selectedCategory: number;
	onSelect: (id: number) => void;
}

const List: React.FC<Props> = ({ categories, selectedCategory, onSelect }) => {
	const { List: css } = useTheme('MealService');
	const { t } = useTranslation('MealService');

	return (
		<div className={css.wrapper}>
			{categories.map(item => (
				<div
					key={item.title}
					title={t(item.title)}
					className={cn(css.item, {
						[css.item_selected]: selectedCategory === item.id
					})}
					onClick={() => onSelect(item.id)}
				>
					{selectedCategory === item.id && <span className={css.item__icon}>{checkIconBig}</span>}
					{t(item.title)}
				</div>
			))}
		</div>
	);
};

export default List;
